/* eslint-disable react-hooks/exhaustive-deps */
import ModalWrap from '@/components/ModalWrap';
import _ from 'lodash';
import { useState } from 'react';

export const HandlePrivateRoute = () => {
    // Start Overtime Room Notification
    const [modal, setModal] = useState<any>({
        visible: false,
        className: '',
        isFooterCancel: false,
        title: '',
        width: 0,
        loading: false,
        body: <></>,
    });

    const onCloseModal = () => {
        setModal({
            visible: false,
        });
    };

    return (
        <>
            <ModalWrap
                visible={modal.visible}
                onCancel={onCloseModal}
                title={modal.title}
                isFooterCancel={true}
                className="overtime-room-notification__wrap"
            >
                {modal.body}
            </ModalWrap>
        </>
    );
};
